<template>
  <Builder
    :chapter="dataObj.introduction.title"
    :dataObj="dataObj.introduction.data"
    :pano="dataObj.introduction.pano"
  />
</template>

<script>
import Builder from "../components/Builder.vue";

export default {
  title: "Introduction",
  components: {
    Builder
  },
  props: {
    dataObj: Object
  }
};
</script>
